<template>
  <v-container fluid class="px-0 py-0">
    <drawer-left>
      <template v-slot:left>
        <div class="pr-3">
          <v-select @change="onDomainChange" label="领域" v-model="domain" :items="domains" item-text="name"
            item-value="id"></v-select>
          <v-select @change="onOrgChange" label="范围" v-model="org" :items="orgs" item-text="name" item-value="id">
          </v-select>
          <tree v-if="catalogCfg" :cfg="catalogCfg" :timestamp="treeTimestamp" @active="onCatalogChange"
            :defaultActiveFirst="unActiveFirst" />
        </div>
      </template>
      <template v-slot:right>
        <crud v-if="crudCfg" :cfg="crudCfg" :timestamp="crudTimestamp" />
      </template>
    </drawer-left>
  </v-container>
</template>

<script>
import { Tree, Crud, DrawerLeft } from "javaee-fre";
export default {
  name: "paper-reop",
  components: {
    tree: Tree,
    crud: Crud,
    "drawer-left": DrawerLeft,
  },
  data() {
    return {
      crudCfg: null,
      crudTimestamp: Date.now(),
      domains: [],
      domain: null,
      orgs: [],
      org: null,
      treeTimestamp: Date.now(),
      catalogCfg: null,
      unActiveFirst: false,
    };
  },
  methods: {
    init() {
      let self = this,
        axios = self.$axios;
      function getDomains() {
        return axios.get("/home/my/tenant/domain/list");
      }
      function getOrgs() {
        return axios.get("/home/my/tenant/org/parent");
      }

      axios.all([getDomains(), getOrgs()]).then(
        axios.spread((r1, r2) => {
          if (r1.data && r1.data.message) {
            self.domains = r1.data.message;
            if (self.domains.length > 0) {
              self.domain = self.domains[0].id;
            }
          }

          let orgs = [];
          if (self.$store.state.account.openRes) {
            orgs.push({ name: "平台共享", id: "_" });
          }
          orgs.push({ name: "企业共享", id: 0 });
          if (r2.data && r2.data.message) {
            orgs.push(...r2.data.message);
          }
          self.orgs = orgs;
          self.org = orgs[0].id;
          self.fillCatalog();
        })
      );
    },
    onDomainChange() {
      this.fillCatalog();
    },
    onOrgChange() {
      this.fillCatalog();
    },
    onCatalogChange(catalog) {
      let self = this,
        cfg = self.crudCfg,
        first = !cfg;
      if (first) {
        cfg = {
          url: "/home/my/paper",
          detailable: false,
          listItemActions: [
            {
              label: "收藏",
              icon: "favorite_border",
              func(cfg) {
                this.$favorite(4, cfg.item.id);
              },
            },
            {
              label: "预览",
              icon: "visibility",
              func(cfg) {
                let self = this;
                self.$dialog.component("试卷预览", "paper-view", {
                  id: cfg.item.id,
                });
              },
            },
          ],
        };
      }
      let params = cfg.params || {};
      params._cata = catalog ? catalog.id : null;
      params._org = self.org == "_" ? null : self.org;
      params._domain = self.domain;
      cfg.params = params;
      if (first) {
        self.crudCfg = cfg;
      } else {
        self.crudTimestamp = Date.now();
      }
    },
    fillCatalog() {
      let self = this,
        cfg = null;

      if (!self.domain) {
        return;
      }
      cfg = {
        label: "label",
        hasChildren(i) {
          return i.catalogCount && i.catalogCount > 0;
        },
        url(i) {
          let r = `/home/my/tenant/catalog/list/${self.domain}/${i ? i.id : 0}`;
          if (self.org || self.org === 0) {
            if (self.org == "_") {
              r = `${r}?_tenant=0`;
            } else {
              r = `${r}?_org=${self.org}`;
            }
          }
          return r;
        },
      };

      self.catalogCfg = cfg;
      self.treeTimestamp = Date.now();
      self.onCatalogChange();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
